import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';
import { SITE, pageTitle } from '@/content/site';

const DEFAULT_IMAGE =
  'https://images.unsplash.com/photo-1511512578047-dfb367046420?w=1200&h=630&fit=crop';

const upsertMeta = (attr, key, content) => {
  let el = document.head.querySelector(`meta[${attr}="${key}"]`);
  if (!el) {
    el = document.createElement('meta');
    el.setAttribute(attr, key);
    document.head.appendChild(el);
  }
  el.setAttribute('content', content);
};

const upsertLink = (rel, href) => {
  let el = document.head.querySelector(`link[rel="${rel}"]`);
  if (!el) {
    el = document.createElement('link');
    el.setAttribute('rel', rel);
    document.head.appendChild(el);
  }
  el.setAttribute('href', href);
};

const setJsonLd = (data) => {
  const id = 'page-jsonld';
  document.getElementById(id)?.remove();
  if (!data) return;
  const el = document.createElement('script');
  el.type = 'application/ld+json';
  el.id = id;
  el.text = JSON.stringify(data);
  document.head.appendChild(el);
};

// Per-route SEO: title, description, canonical, Open Graph, Twitter card, robots and JSON-LD.
export const Seo = ({ title, description, type = 'website', image, noindex = false, jsonLd }) => {
  const { pathname } = useLocation();

  useEffect(() => {
    const fullTitle = pageTitle(title);
    const desc = description || SITE.defaultDescription;
    const url = `${window.location.origin}${pathname}`;
    const img = image || DEFAULT_IMAGE;

    document.title = fullTitle;
    upsertMeta('name', 'description', desc);
    upsertMeta('name', 'robots', noindex ? 'noindex, nofollow' : 'index, follow, max-image-preview:large');
    upsertLink('canonical', url);
    upsertMeta('property', 'og:site_name', SITE.name);
    upsertMeta('property', 'og:title', fullTitle);
    upsertMeta('property', 'og:description', desc);
    upsertMeta('property', 'og:type', type);
    upsertMeta('property', 'og:url', url);
    upsertMeta('property', 'og:image', img);
    upsertMeta('name', 'twitter:card', 'summary_large_image');
    upsertMeta('name', 'twitter:title', fullTitle);
    upsertMeta('name', 'twitter:description', desc);
    upsertMeta('name', 'twitter:image', img);
    setJsonLd(jsonLd);
  }, [title, description, type, image, noindex, jsonLd, pathname]);

  return null;
};
